import { post, get } from './api';

export default {
  create: async function (data) {
    return await post('/attachment/create', data);
  },
  delete: async function (data) {
    return await post('/attachment/delete', data);
  },
  edit: async function (data) {
    return await post('/attachment/edit', data);
  },
  getForVessel: async function (data) {
    return await post('/attachment/get_link', data);
  },
  getAttachmentByType: async function(data) {
    return await post('/public/getAttachmentByType', data);
  }
};
